import { Divider, Form, FormInstance, InputNumber, Row, Select } from "antd";
import ResponsiveCol from "../../../../common/components/form/ResponsiveCol";
import Validations from "./DistributionPointValidations";
import _ from "lodash";
import { useEffect, useMemo } from "react";
import { DistributionPointRequestResource } from "api/generated";
import { isValidEmail } from "services/utils/rfcValidator";
import { FormItem } from "common/components/form/FormItem";

interface MaxDiffetenceDataFormProps {
  formData: FormInstance<DistributionPointRequestResource>;
  globalEmails: string[];
}

function MaxDifferenceDataForm({
  formData,
  globalEmails,
}: MaxDiffetenceDataFormProps) {
  const emails = Form.useWatch("emails", formData);

  const availableEmails = useMemo(() => {
    return _.difference(globalEmails, emails ?? []).map((e: string) => ({
      value: e,
    }));
  }, [globalEmails, emails]);

  // Remove invalid Emails
  useEffect(() => {
    if (emails) {
      const validEmails = emails.filter((email) => isValidEmail(email));
      formData.setFieldValue("emails", validEmails);
    }
  }, [emails]);

  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", color: "#606676" }}
      >
        Configuración de diferencia máxima
      </Divider>
      <Row gutter={24}>
        <ResponsiveCol size="lg">
          <FormItem<DistributionPointRequestResource>
            label="Diferencia Máxima Permitida"
            name="maxDifferencePorcentage"
            rules={Validations.MaxDifferencePercentageRules}
          >
            <InputNumber
              className="common-input"
              precision={7}
              style={{ width: "100%" }}
              placeholder="Diferencia Máxima Permitida"
              addonAfter={Validations.ExtraInfoBtn(
                "Diferencia Máxima Permitida",
                [
                  "Introduce la diferencia máxima permitida en el control de existencias",
                ]
              )}
            />
          </FormItem>
        </ResponsiveCol>
        <ResponsiveCol size="lg">
          <FormItem<DistributionPointRequestResource>
            label="Email"
            name="emails"
            extra="Lista de los emails a notificar cuando la diferencia permitida sea superada"
            rules={Validations.EmailsRules}
          >
            <Select
              style={{ width: "100%" }}
              filterOption={(input, option) => {
                return (
                  option?.value
                    ?.toString()
                    .toLowerCase()
                    .includes(input.toLowerCase()) ?? false
                );
              }}
              options={availableEmails}
              placeholder="Lista de Emails"
              mode="tags"
            />
          </FormItem>
        </ResponsiveCol>
      </Row>
    </div>
  );
}

export default MaxDifferenceDataForm;
